import { differenceInCalendarDays } from 'date-fns';

// Recency highlight for date columns on management lists:
// today → green, yesterday → orange, two days ago → yellow.
// Yellow is MUI yellow[800] — raw yellow is unreadable on a light background.
const RECENCY_COLORS = [
  'success.main',
  'warning.main',
  '#f9a825',
] as const;

export default function getDateRecencyColor(
  input?: string | number | Date,
): string | undefined {
  if (input === undefined || input === null || input === '') {
    return undefined;
  }

  const date = new Date(input);
  if (Number.isNaN(date.getTime())) {
    return undefined;
  }

  const daysAgo = differenceInCalendarDays(new Date(), date);
  if (daysAgo < 0) {
    return undefined;
  }

  return RECENCY_COLORS[daysAgo];
}
